import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ColorSetting } from './color-setting';
import { Setting } from './setting';

export const FrameSetting = (props: ComponentProps<typeof ColorSetting>) => {
  const { t } = useTranslation('content-composer');

  return (
    <Setting title={t('Frame')}>
      <ColorSetting {...props} />
    </Setting>
  );
};
